var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "step-progress m-auto" }, [
    _c(
      "div",
      { staticClass: "step flex justify-between" },
      _vm._l(_vm.steps, function (step, index) {
        return _c(
          "div",
          {
            key: index,
            class: ["relative w-1/2 text-center", _vm.getStepClass(index)],
          },
          [
            _c(
              "span",
              {
                staticClass:
                  "step-number invoice-numbers text-center text-sm font-medium rounded-full flex items-center justify-center m-auto w-5 h-5 mb-1 font-outfit",
              },
              [
                _vm.isStepVisited(index)
                  ? _c("span", { staticClass: "icon" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "14",
                            height: "10",
                            viewBox: "0 0 14 10",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M12.3332 1L4.99984 8.33333L1.6665 5",
                              stroke: "white",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                    ])
                  : _c("span", { staticClass: "number" }, [
                      _vm._v(_vm._s(index + 1)),
                    ]),
              ]
            ),
            _c(
              "span",
              {
                staticClass:
                  "step-label block text-base font-medium text-center font-outfit",
              },
              [_vm._v(" " + _vm._s(step.label) + " ")]
            ),
            _vm.isEditMode() && index === _vm.activeStep
              ? _c(
                  "span",
                  { staticClass: "text-edit" },
                  [_c("EditPenIcon"), _vm._v(" editing ")],
                  1
                )
              : _vm._e(),
            index < _vm.steps.length - 1
              ? _c("div", { staticClass: "step-line block absolute h-0.5" })
              : _vm._e(),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }